// File: src/components/AuthPages/RequireAuthShopify.jsx
import React from 'react';
import { useShopifyAuth } from '../../hooks/useShopifyAuth';
import { Spinner, Page, Layout, Card, Text } from '@shopify/polaris';

/**
 * Authentication wrapper specifically for Shopify embedded apps.
 * Uses session token authentication instead of traditional login.
 */
export default function RequireAuthShopify({ children }) {
  const { loading, error } = useShopifyAuth();

  // Show loading state while authenticating
  if (loading) {
    return (
      <Page>
        <Layout>
          <Layout.Section>
            <Card>
              <div style={{ 
                padding: '40px', 
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px'
              }}>
                <Spinner size="large" />
                <Text variant="headingMd" as="h2">
                  Authenticating with Shopify...
                </Text>
                <Text variant="bodyMd" as="p" tone="subdued">
                  Please wait while we verify your session
                </Text>
              </div>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Show error state if authentication failed
  if (error) {
    return (
      <Page>
        <Layout>
          <Layout.Section>
            <Card>
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <Text variant="headingLg" as="h2" tone="critical">
                  Authentication Error
                </Text>
                <div style={{ marginTop: '16px' }}>
                  <Text variant="bodyMd" as="p">
                    {error}
                  </Text>
                </div>
                <div style={{ marginTop: '20px' }}>
                  <Text variant="bodyMd" as="p" tone="subdued">
                    Please try refreshing the page or reinstalling the app.
                  </Text>
                </div>
              </div>
            </Card>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  // Authentication successful - render protected content
  return <>{children}</>;
}